import { ApolloLink } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
const retryIf = (error, operation) => {
    const isQuery = operation.query.definitions.some((definitionNode) => {
        return definitionNode.kind === 'OperationDefinition' && definitionNode.operation === 'query';
    });
    // 408 allows us to retry errors thrown by our Timeout Link
    const isRetryableError = !!error && error.statusCode !== undefined && (error.statusCode >= 500 || error.statusCode === 408);
    return isQuery && isRetryableError;
};
/*
  A link to provide retry on certain operations.

  We will retry only for Queries with Server Errors. This can be overriden with the retryLink context.
*/
export const makeRetryLink = (maxRetryCount) => new ApolloLink((operation, forward) => {
    var _a, _b, _c, _d, _e, _f;
    const existingContext = operation.getContext();
    const enableRetryLink = (_c = (_b = (_a = existingContext === null || existingContext === void 0 ? void 0 : existingContext.linkOptions) === null || _a === void 0 ? void 0 : _a.retryLink) === null || _b === void 0 ? void 0 : _b.enableRetries) !== null && _c !== void 0 ? _c : true;
    const retryCount = (_f = (_e = (_d = existingContext === null || existingContext === void 0 ? void 0 : existingContext.linkOptions) === null || _d === void 0 ? void 0 : _d.retryLink) === null || _e === void 0 ? void 0 : _e.maxRetryCount) !== null && _f !== void 0 ? _f : maxRetryCount;
    if (!enableRetryLink) {
        return forward(operation);
    }
    const retryLink = new RetryLink({
        attempts: {
            max: retryCount,
            retryIf,
        },
        delay: () => {
            return 0;
        },
    });
    return retryLink.request(operation, forward);
});
